import React from "react";

const StructuredData = ({
  type,
  title,
  description,
  url,
  image,
  authorName,
  publishedAt,
  modifiedAt,
  courseProvider,
}) => {
  const jsonLd =
    type === "article"
      ? {
          "@context": "https://schema.org",
          "@type": "Article",
          headline: title,
          description,
          url,
          image,
          author: { "@type": "Person", name: authorName || "Unknown" },
          datePublished: publishedAt,
          dateModified: modifiedAt,
        }
      : type === "course"
      ? {
          "@context": "https://schema.org",
          "@type": "Course",
          name: title,
          description,
          provider: courseProvider
            ? {
                "@type": "Organization",
                name: courseProvider.name,
                sameAs: courseProvider.url,
              }
            : undefined,
        }
      : {}; // Empty fallback


  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
};

export default StructuredData;
